module.exports = __webpack_public_path__ + "img/19_23.0d417452.png";